<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <p-button *ngIf="$.row.restricted_to_eligible_clients"  [label]="'ADMIN.COUPON.ADD_CLIENTS' | translate" (click)="GetClients($.row)"
    styleClass="text-sm ml-3 py-1"></p-button>
</ng-container>


<coupon-eligible-clients *ngIf="(addClientsModal | async) as show" [tenantId]="tenantId" [couponMaster]="couponMaster" [visible]="show" (closeEvent)="closeEvent($event)">
 </coupon-eligible-clients>